<template>
    <rkm-form
        ref="Form"
        show-legend
    >
        <CidadaoDocumentos
            :data-atual="form.cidadao.dataAtual"
            :form="form.cidadao.documentos"
            :model="model.cidadao"
        />
    </rkm-form>
</template>

<script>
// Components.
import CidadaoDocumentos from '@/components/cadastro/cidadao/Documentos'

export default {
    components: { CidadaoDocumentos },
    props: {
        form: { type: Object, required: true },
        model: { type: Object, required: true },
    },
    methods: {
        validate() {

            return this.$refs.Form.validate()
        },
    }
}
</script>